import { httpJson } from './http';
export class AuthApi {
    baseUrl;
    opts;
    constructor(baseUrl, opts = {}) {
        this.baseUrl = baseUrl;
        this.opts = opts;
    }
    get defaultHeaders() {
        const headers = {};
        if (this.opts.clientType)
            headers['x-eldara-client'] = this.opts.clientType;
        return headers;
    }
    get authOptions() {
        if (!this.opts.tokenProvider)
            return undefined;
        return {
            baseUrl: this.baseUrl,
            tokenProvider: this.opts.tokenProvider,
            refreshHeaders: this.opts.clientType
                ? { 'x-eldara-client': this.opts.clientType }
                : undefined,
        };
    }
    signUp(req) {
        return httpJson(`${this.baseUrl}/auth/sign-up`, {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
            },
            json: req,
            skipAuth: true,
        });
    }
    signIn(req) {
        return httpJson(`${this.baseUrl}/auth/sign-in`, {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
            },
            json: req,
            skipAuth: true,
        });
    }
    refresh(req) {
        return httpJson(`${this.baseUrl}/auth/refresh`, {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
            },
            json: req,
            skipAuth: true,
        });
    }
    signOut(req) {
        return httpJson(`${this.baseUrl}/auth/sign-out`, {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
            },
            json: req,
            skipAuth: true,
        });
    }
    me() {
        return httpJson(`${this.baseUrl}/auth/me`, {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
                'cache-control': 'no-store',
                pragma: 'no-cache',
            },
            auth: this.authOptions,
        });
    }
    requestPasswordReset(email) {
        return httpJson(`${this.baseUrl}/auth/request-password-reset`, {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
            },
            json: { email },
            skipAuth: true,
        });
    }
    confirmPasswordReset(accessToken, newPassword) {
        return httpJson(`${this.baseUrl}/auth/confirm-password-reset`, {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
            },
            json: { accessToken, newPassword },
            skipAuth: true,
        });
    }
    getDevRecoveryLink(accessToken) {
        return httpJson(`${this.baseUrl}/auth/dev/recovery-link`, {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
            json: { accessToken },
            // skipAuth: true,
        });
    }
}
